import React from "react";
import { Link } from "react-router-dom";
import links from "./data";
import NewHeader from "../../../Layouts/NewHeader";
import NewFooter from "../../../Layouts/NewFooter";

const ContactUs = () => {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="container"
          style={{ flex: "1", paddingTop: "20px" }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingTop: "10px",
            }}
            className="card px-3 py-5 shadow-lg mt-2 my-3 m-auto"
          >
            <h1
              className="text-center mt-4"
              style={{ color: "#212529", fontSize: "34px" }}
            >
              Contact Us
            </h1>
            <p className=" my-1 text-center fs-16">
              Chief Engineer (D&R) <br />
              Electricity House. A.G. Colony, Kohima – 797001 <br />
              Email: cepower1helpdesk@gmail.com <br />
              Phone: 0370-2243149 <br />
              Website: <a href="#">https://www.dopn.gov.in/</a>
            </p>
            <h3 className="mt-5 text-center">For Prepaid related queries:</h3>
            <h2
              style={{
                color: "deepskyblue",
                fontWeight: 900,
              }}
              className="text-center mt-2 mb-3"
            >
              DIMAPUR
            </h2>

            <div
              style={{
                height: "100px",
              }}
              className="d-flex justify-content-center align-items-center gap-4"
            >
              <div className="text-center">
                <h3>SDO (E),Sub Division-I </h3>
                <p style={{ fontSize: "18px" }}>PWD Colony </p>
              </div>
              <div
                style={{
                  width: "2px",
                  height: "100%",
                  backgroundColor: "#32a5a0",
                }}
              ></div>
              <div className="text-center">
                <h3>Jain Temple Road </h3>
                <p style={{ fontSize: "18px" }}>Marwari Patti </p>
              </div>
            </div>

            <h3 className="text-center mt-4">Prepaid Consumer Service Point</h3>
            <p className="text-center fs-18">
              Dept. of Power Customer Care Center <br />
              Near Flyover,Burma camp
            </p>

            <h2
              style={{
                color: "deepskyblue",
                fontWeight: 900,
              }}
              className="text-center mt-2 mb-3"
            >
              KOHIMA
            </h2>

            <h3 className="text-center">SDO (E),Sub Division-I</h3>
            <p className="text-center fs-18">Chandmari</p>

            <h3 className="text-center">Prepaid Consumer Service Point</h3>
            <p className="text-center mb-5 fs-18">West road Mall,Jail Colony</p>

            <p className="text-center mt-5 fs-18 mb-2">
              <a href="#">http://prepaidnagaland.com</a>
            </p>
            <p className="text-center fs-18 text-muted">Phone: 8415 900 400</p>
          </div>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default ContactUs;
